"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollableTabList = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _animate = _interopRequireDefault(require("../animate/animate"));

var _ScrollbarSizeListener = require("../ScrollbarSizeListener");

var _utils = require("../utils");

var _fieldUtils = require("../microFields/fieldUtils");

var _TabScrollButton = require("./TabScrollButton");

var _TabList = require("./TabList");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ScrollableTabList =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollableTabList, _Component);

  function ScrollableTabList(props) {
    var _this;

    _classCallCheck(this, ScrollableTabList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollableTabList).call(this, props));
    var _this$props = _this.props,
        tabItems = _this$props.tabItems,
        defaultValue = _this$props.defaultValue;
    _this.state = {
      value: defaultValue || tabItems[0].value,
      selectedTabMeta: {},
      showLeftScroll: false,
      showRightScroll: false,
      scrollerStyle: {
        marginBottom: 0
      },
      fullWidth: false
    };
    _this.tabListRef = null;
    _this.handleResize = (0, _utils.debounce)(function () {
      _this.updateScrollButtonState();

      _this.resetWidth();
    }, 166); // Corresponds to 10 frames at 60 Hz.

    _this.handleTabsScroll = (0, _utils.debounce)(function () {
      _this.updateScrollButtonState();
    }, 166); // Corresponds to 10 frames at 60 Hz.

    _this.setTabListRef = _this.setTabListRef.bind(_assertThisInitialized(_this));
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    _this.handleLeftScrollClick = _this.handleLeftScrollClick.bind(_assertThisInitialized(_this));
    _this.handleRightScrollClick = _this.handleRightScrollClick.bind(_assertThisInitialized(_this));
    _this.handleScrollbarSizeChange = _this.handleScrollbarSizeChange.bind(_assertThisInitialized(_this));
    _this.moveTabsScroll = _this.moveTabsScroll.bind(_assertThisInitialized(_this));
    _this.resetWidth = _this.resetWidth.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ScrollableTabList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateScrollButtonState();
      window.addEventListener('resize', this.handleResize);
      this.resetWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state = this.state,
          value = _this$state.value,
          selectedTabMeta = _this$state.selectedTabMeta;
      var prevValue = prevState.value;
      var prevTabMeta = prevState.selectedTabMeta;
      this.updateScrollButtonState();

      if (prevValue !== value || !Object.is(prevTabMeta, selectedTabMeta)) {
        this.scrollSelectedIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
      this.handleTabsScroll.clear();
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "setTabListRef",
    value: function setTabListRef(element) {
      this.tabListRef = element;
    }
  }, {
    key: "getConditionalElements",
    value: function getConditionalElements() {
      var _this$props2 = this.props,
          scrollButtons = _this$props2.scrollButtons,
          cashbotName = _this$props2.cashbotName;
      var _this$state2 = this.state,
          showLeftScroll = _this$state2.showLeftScroll,
          showRightScroll = _this$state2.showRightScroll;
      var conditionalElements = {};
      var showScrollButtons = scrollButtons === _TabScrollButton.DISPLAY_TYPE.AUTO || scrollButtons === _TabScrollButton.DISPLAY_TYPE.ON;
      conditionalElements.scrollButtonLeft = showScrollButtons ? _react.default.createElement(_TabScrollButton.TabScrollButton, {
        cashbotName: cashbotName,
        direction: _TabScrollButton.SCROLL_DIRECTION.LEFT,
        handleClick: this.handleLeftScrollClick,
        visible: showLeftScroll,
        displayType: scrollButtons
      }) : null;
      conditionalElements.scrollButtonRight = showScrollButtons ? _react.default.createElement(_TabScrollButton.TabScrollButton, {
        cashbotName: cashbotName,
        direction: _TabScrollButton.SCROLL_DIRECTION.RIGHT,
        handleClick: this.handleRightScrollClick,
        visible: showRightScroll,
        displayType: scrollButtons
      }) : null;
      return conditionalElements;
    }
  }, {
    key: "getTabsMeta",
    value: function getTabsMeta() {
      var tabsMeta = {};

      if (this.tabListRef) {
        var rect = this.tabListRef.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft

        tabsMeta = {
          clientWidth: this.tabListRef.clientWidth,
          scrollLeft: this.tabListRef.scrollLeft,
          scrollWidth: this.tabListRef.scrollWidth,
          left: rect.left,
          right: rect.right
        };
      }

      return tabsMeta;
    }
  }, {
    key: "resetWidth",
    value: function resetWidth() {
      var tabsMeta = this.getTabsMeta();

      if (tabsMeta.scrollWidth && tabsMeta.clientWidth) {
        var fullWidth = tabsMeta.scrollWidth <= tabsMeta.clientWidth;
        this.setState({
          fullWidth: fullWidth
        });
      }
    }
  }, {
    key: "updateScrollButtonState",
    value: function updateScrollButtonState() {
      var scrollButtons = this.props.scrollButtons;
      var _this$state3 = this.state,
          showLeftScroll = _this$state3.showLeftScroll,
          showRightScroll = _this$state3.showRightScroll;

      if (this.tabListRef && scrollButtons !== 'off') {
        var _this$tabListRef = this.tabListRef,
            scrollLeft = _this$tabListRef.scrollLeft,
            scrollWidth = _this$tabListRef.scrollWidth,
            clientWidth = _this$tabListRef.clientWidth;
        var shouldShowLeftScroll = scrollLeft > 0;
        var shouldShowRightScroll = scrollWidth > clientWidth + scrollLeft;

        if (shouldShowLeftScroll !== showLeftScroll || shouldShowRightScroll !== showRightScroll) {
          this.setState({
            showLeftScroll: shouldShowLeftScroll,
            showRightScroll: shouldShowRightScroll
          });
        }
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(tab, tabMeta) {
      if (!tab) return;
      var handleSelect = this.props.handleSelect;
      this.setState({
        value: tab,
        selectedTabMeta: tabMeta
      });
      handleSelect(tab);
    }
  }, {
    key: "handleLeftScrollClick",
    value: function handleLeftScrollClick() {
      this.moveTabsScroll(-this.tabListRef.clientWidth);
    }
  }, {
    key: "handleRightScrollClick",
    value: function handleRightScrollClick() {
      this.moveTabsScroll(this.tabListRef.clientWidth);
    }
  }, {
    key: "handleScrollbarSizeChange",
    value: function handleScrollbarSizeChange(_ref) {
      var scrollbarHeight = _ref.scrollbarHeight;
      this.setState({
        scrollerStyle: {
          marginBottom: -scrollbarHeight
        }
      });
    }
  }, {
    key: "moveTabsScroll",
    value: function moveTabsScroll(delta) {
      var nextScrollLeft = this.tabListRef.scrollLeft + delta;
      this.scroll(nextScrollLeft);
    }
  }, {
    key: "scrollSelectedIntoView",
    value: function scrollSelectedIntoView() {
      var selectedTabMeta = this.state.selectedTabMeta;
      var tabsMeta = this.getTabsMeta();

      if (!selectedTabMeta || !tabsMeta) {
        return;
      }

      if (selectedTabMeta.left < tabsMeta.left) {
        // left side of button is out of view
        var nextScrollLeft = tabsMeta.scrollLeft + (selectedTabMeta.left - tabsMeta.left);
        this.scroll(nextScrollLeft);
      } else if (selectedTabMeta.right > tabsMeta.right) {
        // right side of button is out of view
        var _nextScrollLeft = tabsMeta.scrollLeft + (selectedTabMeta.right - tabsMeta.right);

        this.scroll(_nextScrollLeft);
      }
    }
  }, {
    key: "scroll",
    value: function scroll(value) {
      (0, _animate.default)('scrollLeft', this.tabListRef, value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          name = _this$props3.name,
          cashbotName = _this$props3.cashbotName,
          legend = _this$props3.legend,
          doFocus = _this$props3.doFocus,
          hasTabPanel = _this$props3.hasTabPanel,
          tabItems = _this$props3.tabItems,
          defaultValue = _this$props3.defaultValue;
      var fullWidth = this.state.fullWidth;
      var conditionalElements = this.getConditionalElements();
      return _react.default.createElement("div", {
        className: "scroll-container"
      }, _react.default.createElement(_ScrollbarSizeListener.ScrollbarSizeListener, {
        handleLoad: this.handleScrollbarSizeChange,
        handleChange: this.handleScrollbarSizeChange
      }), _react.default.createElement("div", {
        className: "flex"
      }, conditionalElements.scrollButtonLeft, _react.default.createElement(_TabList.TabList, {
        name: name,
        cashbotName: cashbotName,
        cssClass: "tab-container--scrollable",
        style: this.state.scrollerStyle,
        legend: legend,
        doFocus: doFocus,
        tabItems: tabItems,
        defaultValue: defaultValue,
        handleSelect: this.handleSelect,
        fullWidth: fullWidth,
        hasTabPanel: hasTabPanel,
        innerRef: this.setTabListRef,
        innerWrapper: function innerWrapper(tabs) {
          return _react.default.createElement("div", {
            className: "flex"
          }, tabs);
        }
      }), conditionalElements.scrollButtonRight));
    }
  }]);

  return ScrollableTabList;
}(_react.Component);

exports.ScrollableTabList = ScrollableTabList;
ScrollableTabList.defaultProps = {
  doFocus: false,
  defaultValue: null,
  handleSelect: function handleSelect() {},
  hasTabPanel: false,
  scrollButtons: _TabScrollButton.DISPLAY_TYPE.AUTO
};
ScrollableTabList.propTypes = {
  name: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  legend: _propTypes.default.string.isRequired,
  doFocus: _propTypes.default.bool,

  /**
   * Array of objects in the shape { label: {string}, value: {string|number} }
   */
  tabItems: _fieldUtils.optionsPropTypes.isRequired,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  handleSelect: _propTypes.default.func,
  hasTabPanel: _propTypes.default.bool,
  // NOTE: not fully implemented yet

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes.default.oneOf([_TabScrollButton.DISPLAY_TYPE.AUTO, _TabScrollButton.DISPLAY_TYPE.ON, _TabScrollButton.DISPLAY_TYPE.OFF])
};